import {
  useMutation,
  useQueryClient,
} from '@tanstack/react-query';
import { backendErrorsHandler } from '../../utils/Notification/BackendErrorsHandler';
import { requestStoreReviewByCustomerIdV2 } from '../../services/reviews.service';
const listQueryKey = 'reviews';

export const useRequestCustomerReview = (storeId: string) => {
  const queryClient = useQueryClient()
  return useMutation({
    mutationFn: async (customerId: string) => {
      try {
        const res = await requestStoreReviewByCustomerIdV2(storeId, customerId);
        if (!res?.data?.data) {
          throw new Error('Oh no! Something went wrong while fetching.');
        }
        return res.data.data;
      } catch (e: any) {
        console.log('error caught', e['response']?.data?.['errors']);
        backendErrorsHandler(e);
        throw e;
      }
    },
    onSuccess: async () => {
      return Promise.all([queryClient.invalidateQueries({
        queryKey: [listQueryKey, { storeId: storeId }],
      })]);
    }
  });
};
